<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-right">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Help & Support</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
          <CCard class="card-custom-blue text-center" style="height: 170px;">
            <div class="text-center">
              <label class="mt-3" style="font-size: 20px; font-weight: 600px; color: #FAFAFA;"> How can we help you ? </label>
              <label class="custom-14px" style="font-weight: 400; color: #FAFAFA; margin-bottom: 20px;"> A fully functional search system </label> 
              <div class="" style="
                border-radius: 1000px;
                background: rgba(255, 255, 255, 0.15);  
                display: flex;
                width: 100%;
                padding: 13px;
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
                height:45px;" >
                <img src="../assets/img/iconsearch.png" style="width: 16px;"/>
                <label class="custom-12px" style="margin-top: -25px; margin-left: 25px; color: #FAFAFA"> Search... </label>
              </div>
            </div>
          </CCard>

          <CRow class="m-0">
            <div class="" style="
              border-radius: 1000px;
              background: #F5F5F5;  
              display: flex;
              width: 48%;
              padding: 13px;
              flex-direction: column;
              align-items: flex-start;
              gap: 10px;
              height:45px;
              margin-right: 5px;" >
              <img src="../assets/img/message.png" style="width: 16px;"/>
              <label class="custom-12px" style="margin-top: -25px; margin-left: 25px; color: #212529;"> Email Support </label>
            </div>

            <div class="" style="
              border-radius: 1000px;
              background: #F5F5F5;  
              display: flex;
              width: 48%;
              padding: 13px;
              flex-direction: column;
              align-items: flex-start;
              gap: 10px;
              height:45px;
              margin-left: 5px;" >
              <img src="../assets/img/sms.png" style="width: 16px;"/>
              <label class="custom-12px" style="margin-top: -25px; margin-left: 25px; color: #212529;"> Live Chat </label>
            </div>
          </CRow>

          <label class="mt-3 mb-0" style="font-size: 20px; font-weight: 600px; color: #212529;"> Frequent Question </label>
          <label class="custom-12px" style="font-weight: 400; margin-bottom: 20px;"> Help you out identifying what you need faster. </label> 

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 1. What is Genie Workers? </label>
              <div class="float-right">
                <img src="../assets/img/close.png" style="width: 20px;"/>
              </div>
            </div>
            <label class="custom-12px mb-0" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label> 
          </CCard>

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 2.How does Genie Workers work? </label>
              <div class="float-right">
                <img src="../assets/img/add-bold.png" style="width: 20px;"/>
              </div>
            </div>
            <!-- <label class="custom-12px" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label>  -->
          </CCard>

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 3. Is Genie Workers available in my area? </label>
              <div class="float-right">
                <img src="../assets/img/add-bold.png" style="width: 20px;"/>
              </div>
            </div>
            <!-- <label class="custom-12px" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label>  -->
          </CCard>

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 4. What types of services are available on Genie Workers? </label>
              <div class="float-right">
                <img src="../assets/img/add-bold.png" style="width: 20px;"/>
              </div>
            </div>
            <!-- <label class="custom-12px" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label>  -->
          </CCard>

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 5. How do I book a service on Genie Workers? </label>
              <div class="float-right">
                <img src="../assets/img/add-bold.png" style="width: 20px;"/>
              </div>
            </div>
            <!-- <label class="custom-12px" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label>  -->
          </CCard>

          <CCard class="mb-3" style="
            border-radius: 12px;
            border: 1px solid var(--Grayscale-200, #212529);
            background: var(--Neutral-Background, #F9F9F9);
            padding: 15px;">
            <div>
              <label class="custom-14px mb-0" style="font-weight: 500; color: #212529; width: 90%;"> 6. Can I communicate with the service provider directly? </label>
              <div class="float-right">
                <img src="../assets/img/add-bold.png" style="width: 20px;"/>
              </div>
            </div>
            <!-- <label class="custom-12px" style="font-weight: 500; width: 90%;"> Genie Workers is an AI-powered platform designed to connect users with a wide range of service providers. From home maintenance to cleaning and repairs, Genie Workers simplifies the process of finding and booking reliable services </label>  -->
          </CCard>
          
          <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          
          
          <br /><br />
        </div>
      
             
      
      
      
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
              successPopup: false,
  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        GoToWhatsapp() {
          this.$router.push("/EditProfile");
        },

        connectSuccess() {
          this.successPopup = true;
        },

        closePopup() {
          this.$router.push("/EditSocmed");
        }
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }

  .switch {
  position: relative;
  display: inline-grid;
  width: 50px;
  height: 25px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #DDE0EE;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #323C66;
}



input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
  </style>